const faSlidersUp = {
  prefix: 'fal',
  iconName: 'sliders-up',
  icon: [
    512,
    512,
    ['sliders-v'],
    'f3f1',
    'M96 0c8.8 0 16 7.2 16 16l0 65.6c36.5 7.4 64 39.7 64 78.4s-27.5 71-64 78.4L112 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-257.6C43.5 231 16 198.7 16 160S43.5 89 80 81.6L80 16C80 7.2 87.2 0 96 0zm0 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 400a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80-48c0 38.7-27.5 71-64 78.4l0 65.6c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-65.6c-36.5-7.4-64-39.7-64-78.4s27.5-71 64-78.4L240 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 257.6c36.5 7.4 64 39.7 64 78.4zM464 192a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-32 78.4L432 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-225.6c-36.5-7.4-64-39.7-64-78.4s27.5-71 64-78.4L400 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 97.6c36.5 7.4 64 39.7 64 78.4s-27.5 71-64 78.4z',
  ],
};
export default faSlidersUp;
